export const NOT_STARTED = 'not_started';
export const STARTED = 'started';
export const COMPLETE = 'complete';
export const FAILED = 'failed';
